// @module ROOM4.CCAProductImageEventOverlay.CCAItemClearanceImageOverlay
define("ROOM4.CCAProductImageEventOverlay.CCAItemClearanceImageOverlay.View", [
  "room4_ccaproductimageeventoverlay_ccaitemclearanceimageoverlay.tpl",
  "SCView",
], function (
  room4_ccaproductimageeventoverlay_ccaitemclearanceimageoverlay_tpl,
  SCViewModule,
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  function ClearanceImageOverlayView(config) {
    SCView.call(this, config);
    this.template =
      room4_ccaproductimageeventoverlay_ccaitemclearanceimageoverlay_tpl;
    this.contextDataRequest = ["item"];
  }

  ClearanceImageOverlayView.prototype = Object.create(SCView.prototype);
  ClearanceImageOverlayView.prototype.constructor = ClearanceImageOverlayView;

  ClearanceImageOverlayView.prototype.getContext = function () {
    var clearance = this.contextData.item().custitem6;
    var clearanceImage = clearance
      ? "https://www.canadacustomautoworks.com/site/promotion-images/clearance/clearance.png"
      : null;

    return {
      clearance: clearance,
      clearanceImage: clearanceImage,
    };
  };

  return ClearanceImageOverlayView;
});
